import "../../assets/style/main.css";
import "./style.scss"
import { useEffect, useRef, useState, useCallback } from "react";
import $, { event } from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from "../../utils/Encryption";
import moment from "moment";
import { Base_API } from "../../_actions/matcher";
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import PREVIEW_FILE_ICON from '../../assets/images/icons/preview-file.png'
import Breadcrumb_Step from "../../components/Breadcrumb_Step";
import Image_Upload from '../../assets/images/icons/upload.png';
import ContentLoader from "../../components/ContentLoader";
import { isContentLoading } from "../../components/ContentLoader";
import { getJWTbyPatientID } from "../../_actions/sso.authen";
import { NhealthAction } from "../../_actions/action.api";
import ImageViewer from 'react-simple-image-viewer';


export default function KYC_Step_4() {

    let onceMount = useRef(true);
    let INPUT_CHECKED = useRef();

    const [fileName, setFileName] = useState([]);
    const [filePreview, setFilePreview] = useState([]);
    const [fileStore, setFileStore] = useState([]);
    const [errMsg, setErrMsg] = useState("");
    const [confirmTerms, setConfirmTerms] = useState(false);

    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [imagePreview, setImagePreview] = useState("");

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    const handleFile = async(file) => {
        console.log('file: ', file);
        isContentLoading(true)
        setFileName([...fileName, file.name]);
        setErrMsg("");

        const url = URL.createObjectURL(file);
        console.log('url preview: ', url);
        let type = String(file.type).split('/')[1];
        setFilePreview([...filePreview, {url: url, type: type, name: file.name}]);
        
        // await uploadImage(file)

        isContentLoading(false)
    };

    const uploadImage = (file) => {
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            console.log(patientData);
            let patientID = patientData.data.patientid;
            let jwtData = await getJWTbyPatientID(patientID);

            let formData = new FormData();
            formData.append('file', file);

            let headers = {
                token: jwtData.token,
                userRef: patientID,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            NhealthAction.uploadImage(formData, headers)
            .then(res => {
                console.log(res);
                if(res.IsSuccess)
                {
                    let pathFile = !!res.data[0]._image ? res.data[0]._image : ""; 
                    let newFile = fileStore;
                    newFile.push({_image: pathFile, _filename: file.name})
                    setFileStore(newFile)

                    resolve();
                }else
                {
                    if(res.statusCode === 400)
                    {
                       openAlert('ไม่สำเร็จ', 'กรุณาอัปโหลดไฟล์ png, jpg, jpeg', 'ตกลง'); 
                    }
                    resolve();
                }
            })
        })
    }

    const FileUploaders = ({ handleFile }) => {
        const hiddenFileInput = useRef(null);

        const handleCilek = event => {
            hiddenFileInput.current.click();
        }

        const handleChanges = event => {
            const FileUploaded = event.target.files[0];
            handleFile(FileUploaded)
        }

        return (
            <>
                <button className="button-upload" onClick={handleCilek}>
                    <img src={Image_Upload} alt="" width={32} height={32} />
                    <p>อัพโหลด</p>
                </button>
                <input type="file" onChange={handleChanges} ref={hiddenFileInput} style={{ display: 'none' }} />
            </>
        )
    }

    const handleRemoveFile = (file_name) => {
        let newFiles = fileName.filter(item => item !== file_name);
        let newFilesPreview = filePreview.filter(item => item.name !== file_name)
        let newFilesStore = fileStore.filter(item => item._filename !== file_name);
        setFileName(newFiles);
        setFilePreview(newFilesPreview);
        setFileStore(newFilesStore);
    }

    const pageInit = async () => {
        isPageLoading(false);
    };

    const onSubmit = async(e) => {
        e.preventDefault();
        await submitForm()
        .then(() => {
            nextPage();
        })
    }

    const submitForm = () => {
        return new Promise(async resolve => {
            if(fileStore.length > 0)
            {
                let checked = INPUT_CHECKED.current.checked;
                if(checked)
                {
                    let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;             
                    if(!!updateKycPayload)
                    {
                        let newFileStore = fileStore.map(item => ({_image: item._image}));
                        let newForm = {
                            ...updateKycPayload,
                            more_uplaod: newFileStore,
                        }
                        console.log(newForm); 
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, EncryptedOBJ(newForm)) 
                        resolve();
                    }
                }
            }else
            {
                let checked = INPUT_CHECKED.current.checked;
                if(checked)
                {
                    let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;             
                    if(!!updateKycPayload)
                    {
                        let newForm = {
                            ...updateKycPayload,
                            more_uplaod: [],
                        }
                        console.log(newForm); 
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, EncryptedOBJ(newForm)) 
                        resolve();
                    }
                }
            }
        })
    }

    const nextPage = () => {
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME); 
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA); 
        window.location.href = `${Base_API.pathWeb}/n-health/signup/otp`;
    }
    const onSkip = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/step-2`;
    }

    const handleChagneCheckbox = (e) => {
        let checked = e.target.checked
        setConfirmTerms(checked);
    }

    const openImageViewer = useCallback((url) => {
        setImagePreview(url);
        setIsViewerOpen(true);
    }, []);
    
    const closeImageViewer = () => {
        setImagePreview("");
        setCurrentImage(0);
        setIsViewerOpen(false);
    };

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src={CLOSE_ICON} />
                </div>
        
                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>
        
                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );
    
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    
    };
    
    const handleCloseAlert = () => {
        MySwal.close();
    };

    return (
        <>
            <div className="kyc-step-4-con container-profile">
                <PageLoader />
                <SignIn_Navbar canClose={false} />
                <Breadcrumb_Step step={4} />
                <ContentLoader/>

                <h3 className="header-text">
                    อัพโหลดไฟล์
                </h3>

                <div className="form-wrap">
                    <div className="form-group" name="fname">
                        <label htmlFor="fname">กรุณาอัพโหลดรูปถ่ายและเอกสารที่เกี่ยวข้อง</label>
                        <FileUploaders handleFile={handleFile} />
                        <div className="file-preview-group">
                            {filePreview.length > 0 && filePreview.map((item, i) => (
                                <div className="item-wrap" onClick={() => {
                                    if(item.type === 'png' || item.type === 'jpg' || item.type === 'jpeg')
                                    openImageViewer(item.url)
                                }}>
                                    <div className="item" key={i}>
                                        {item.type === 'png' || item.type === 'jpg' || item.type === 'jpeg'
                                            ? <img className="prv-img" src={item.url} /> 
                                            : <img className="prv-file" src={PREVIEW_FILE_ICON} />
                                        }
                                        <button type="button" className="remove-file-btn" onClick={() => handleRemoveFile(item.name)}>
                                            <img src={CLOSE_ICON} />
                                        </button>
                                    </div>
                                    <p className="filename">{item.name}</p>
                                </div>
                            ))}
                        </div>
                        <p className="text-error">{errMsg}</p>
                    </div>

                    <div className="form-detail">
                        <p>ข้าพเจ้าขอรับรองว่าข้อมูลที่ให้ไว้ในแบบฟอร์มนี้ถูกต้องและครบถ้วน ฉันยืนยันว่าข้อมูลใดๆ ที่พบว่าไม่ถูกต้องและ/หรือไม่สมบูรณ์ซึ่งนำไปสู่การละเมิดกฎระเบียบอาจเริ่มต้นการดำเนิน
                            การทางกฎหมาย และฉันยอมรับว่าฉันเป็นผู้รับผิดชอบต่อค่าใช้จ่าย บทลงโทษ และการละเมิดใดๆ และทั้งหมด</p>
                    </div>

                    <div className="form-group">
                        <label htmlFor='confirm' className="top">
                            <input type="checkbox" ref={INPUT_CHECKED} onChange={handleChagneCheckbox} id="confirm" />
                            <label htmlFor='confirm'>ฉันยอมรับข้อตกลงและเงื่อนไขของบริการ</label>
                        </label>
                    </div>

                    {/* <button 
                        className={`btn-save`} type="button" 
                        // onClick={onSubmit}
                        onClick={onSkip}
                    >
                        บันทึกข้อมูล
                    </button> */}
                    <button
                        className={`btn-submit ${confirmTerms ? '' : 'disabled'}`} type="submit"
                        onClick={confirmTerms ? onSubmit : null}
                        // onClick={onSkip}
                    >
                        ดำเนินการต่อ
                    </button>
                </div>
                {/* <PrivacyPolicy /> */}
            </div>
            {isViewerOpen && 
                <>
                <ImageViewer 
                    src={ [imagePreview] }
                    currentIndex={ currentImage }
                    disableScroll={ false }
                    closeOnClickOutside={ true }
                    onClose={ closeImageViewer }
                />
                <button className="kyc-4-close-preview-btn" onClick={closeImageViewer}>
                    <img src={CLOSE_ICON} />
                </button>
                </>
            }
        </>
    );
}
